import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PortfolioContext = createContext(null);

export function PortfolioProvider({ children }) {
    const { user } = useAuth();
    const [subs, setSubs] = useState([]);
    const [selectedSub, setSelectedSub] = useState("ALL");

    const loadSubs = useCallback(async () => {
        try {
            const { data } = await api.get("/subportfolios");
            setSubs(data);
        } catch (e) { console.error("Failed to load sub-portfolios:", e); }
    }, []);

    useEffect(() => { if (user) loadSubs(); }, [user, loadSubs]);

    return (
        <PortfolioContext.Provider value={{ subs, selectedSub, setSelectedSub, refreshSubs: loadSubs }}>
            {children}
        </PortfolioContext.Provider>
    );
}

export const usePortfolio = () => useContext(PortfolioContext);
